// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef86c1bb","455":"42627396","977":"f7c9cee8"}[chunkId] + ".chunk.js";
};